import { axiosGet, axiosPost, axiosDelete, axiosPut } from "../options/header";


// Get all case analytics for year
const getAnalytics = async (year) => {
    try {
        const response = await axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + '/analytics/case', {
            params: {
              year: year,
            },
            credentials: true
          });
        return response;
    } catch (error) {
        console.error("Error retrieving categories", error);
    }
};














export {
    getAnalytics,
}
